(() => {
  let ctrl, observers = [];
  function boot() {
  if (ctrl) ctrl.abort();
  observers.forEach(o => o.disconnect());
  observers = [];
  ctrl = new AbortController();
  const sig = ctrl.signal;
  const q = k => document.querySelector('[data-k="' + k + '"]');
  const clamp = v => Math.min(1, Math.max(0, v));
  const smooth = v => v * v * (3 - 2 * v);
  const smoother = v => Math.pow(v, 3) * (v * (v * 6 - 15) + 10);
  const mix = (a, b, p) => a + (b - a) * p;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');

  const hero = q('hero'), mark = q('mark'), lettermark = q('lettermark'),
        manifesto = q('manifesto'), product = q('product'), newsletter = q('newsletter'),
        footer = q('footer'),
        erleben = q('erleben'), besuch = q('besuch'), intro = q('intro');
  let frame = 0, heroTarget = 0, heroCurrent = 0;

  function paintHero() {
    if (!hero) return false;
    const rect = hero.getBoundingClientRect();
    const range = Math.max(hero.offsetHeight - innerHeight, 1);
    const red = reduced.matches;
    heroTarget = red ? 1 : clamp(-rect.top / range);
    const delta = heroTarget - heroCurrent;
    heroCurrent = red || Math.abs(delta) < .00035 ? heroTarget : heroCurrent + delta * .12;
    const p = heroCurrent;
    const dock = smoother(clamp((p - .05) / .43));
    const handoff = smoother(clamp((p - .43) / .11));
    if (mark && lettermark) {
      const b = lettermark.getBoundingClientRect();
      const dx = b.left + b.width / 2 - innerWidth / 2;
      const dy = b.top + b.height / 2 - innerHeight / 2;
      const scale = b.width / Math.max(mark.offsetWidth, 1);
      mark.style.transform = 'translate3d(' + dx * dock + 'px,' + dy * dock + 'px,0) scale(' + mix(1, scale, dock) + ')';
      mark.style.opacity = 1 - handoff;
      lettermark.style.setProperty('--nav-logo-opacity', handoff);
    }
    const set = (k, v) => hero.style.setProperty(k, v);
    const scene = smooth(clamp((p - .08) / .2)), open = smooth(clamp((p - .14) / .31));
    const figureIn = smooth(clamp((p - .22) / .17)), story = smooth(clamp((p - .24) / .32));
    const figure = figureIn * (1 - smooth(clamp((p - .62) / .14)));
    const copyOut = smooth(clamp((p - .58) / .13));
    const exit = smoother(clamp((p - .84) / .16));
    set('--editorial-reveal', scene); set('--scene-opacity', scene); set('--editorial-open', open);
    set('--figure-visible', figure);
    set('--issue-visible', smooth(clamp((p - .34) / .13)) * (1 - copyOut));
    set('--caption-visible', smooth(clamp((p - .39) / .13)) * (1 - copyOut));
    set('--track-visible', .11 * smooth(clamp((p - .47) / .13)));
    set('--meta-visible', smooth(clamp((p - .5) / .12)) * (1 - smooth(clamp((p - .65) / .1))));
    set('--editorial-image-scale', mix(1.14, 1.02, open));
    set('--editorial-image-y', mix(3, -2, open) + '%');
    set('--editorial-handoff-y', mix(0, -2.2, exit) + '%');
    set('--editorial-handoff-scale', mix(1, 1.022, exit));
    set('--editorial-handoff-opacity', 1 - exit * .86);
    set('--grade-opacity', mix(.45, 1, scene));
    set('--figure-x', (mix(6, 0, figureIn) - mix(0, 1.5, story)) + 'vw');
    set('--figure-y', (mix(7, 1.4, figureIn) - mix(0, 2.6, story)) + 'vh');
    set('--figure-scale', mix(.92, .985, figureIn) + mix(0, .035, story));
    set('--issue-x', mix(4, 0, smooth(clamp((p - .34) / .13))) + 'vw');
    set('--caption-y', mix(5, 0, smooth(clamp((p - .39) / .13))) + 'vh');
    const track = smooth(clamp((p - .47) / .38));
    set('--track-left', mix(0, -16, track) + 'vw');
    set('--track-right', mix(0, 11, track) + 'vw');
    const content = smooth(clamp((p - .66) / .11)), contentExit = smoother(clamp((p - .9) / .1));
    set('--cinema-content-opacity', content * (1 - contentExit));
    set('--cinema-content-y', (mix(30, 0, content) - mix(0, 18, contentExit)) + 'px');
    return Math.abs(heroTarget - heroCurrent) > .00001;
  }

  function paintNewsletter() {
    if (!newsletter) return;
    const r = newsletter.getBoundingClientRect();
    const p = (innerHeight - r.top) / Math.max(innerHeight + r.height, 1);
    newsletter.style.setProperty('--px', reduced.matches ? .5 : clamp(p));
  }
  function paintManifesto() {
    if (!manifesto) return;
    const r = manifesto.getBoundingClientRect(), range = Math.max(manifesto.offsetHeight - innerHeight, 1);
    manifesto.style.setProperty('--manifesto-progress', reduced.matches ? .72 : clamp(-r.top / range));
  }
  function paintProduct() {
    if (!product) return;
    const r = product.getBoundingClientRect(), travel = Math.max(product.offsetHeight - innerHeight, 1);
    const p = reduced.matches ? 1 : clamp(-r.top / travel);
    const raw = clamp((p - .14) / .3);
    product.style.setProperty('--product-motion', clamp(p / .62));
    product.style.setProperty('--product-reveal', raw * raw * (3 - 2 * raw));
  }

  function band(node, prop) {
    if (!node) return;
    const r = node.getBoundingClientRect();
    const p = (innerHeight - r.top) / Math.max(innerHeight + r.height, 1);
    node.style.setProperty(prop, reduced.matches ? .5 : clamp(p));
  }

  // Parallax: -1 wenn das Element unten ins Bild kommt, 0 mittig, +1 beim Verlassen oben.
  const parallaxNodes = [...document.querySelectorAll('[data-parallax]')];
  function paintParallax() {
    if (!parallaxNodes.length) return;
    for (const node of parallaxNodes) {
      if (reduced.matches) { node.style.setProperty('--par', 0); continue; }
      const r = node.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) continue;
      const mitte = r.top + r.height / 2;
      node.style.setProperty('--par', (clamp(mitte / innerHeight) * 2 - 1).toFixed(4));
    }
  }

  function update() {
    frame = 0;
    const keep = paintHero();
    paintNewsletter(); paintManifesto(); paintProduct(); paintParallax();
    band(erleben, '--ex'); band(besuch, '--bx');
    // --ix traegt die Kulisse und die Zierleiste im Intro (kindl.css Block 10)
    band(intro, '--ix');
    if (keep) frame = requestAnimationFrame(update);
  }
  const request = () => { if (!frame) frame = requestAnimationFrame(update); };
  addEventListener('scroll', request, { passive: true, signal: sig });
  addEventListener('resize', request, { passive: true, signal: sig });
  reduced.addEventListener('change', request, { signal: sig });

  if (footer) {
    const io = new IntersectionObserver(function (e, o) {
      if (e[0].isIntersecting) { footer.style.setProperty('--fr', 1); o.disconnect(); }
    }, { threshold: .12 });
    io.observe(footer); observers.push(io);
  }
  // .rv ist auf den Inhaltsseiten als Einblende-Markierung gemeint, traegt aber
  // kein data-reveal. Das Attribut wird hier nachgeruestet, damit die bestehende
  // Mechanik (Staffelung ueber --d, prefers-reduced-motion) greift. Bewusst per
  // JavaScript und nicht als .rv{opacity:0} in kindl.css: faellt das Skript aus,
  // wird nichts unsichtbar gesetzt und die Inhalte stehen sofort da.
  document.querySelectorAll('.rv:not([data-reveal])').forEach(el => el.setAttribute('data-reveal', ''));

  const revealIo = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.setAttribute('data-in', '');
      else if (e.boundingClientRect.top > 0) e.target.removeAttribute('data-in');
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
  document.querySelectorAll('[data-reveal]').forEach(el => revealIo.observe(el));
  observers.push(revealIo);
  // Sicherheitsnetz: was beim Laden schon im Bild ist, wird sichtbar
  requestAnimationFrame(() => document.querySelectorAll('[data-reveal]:not([data-in])').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top < innerHeight * .92 && r.bottom > 0) el.setAttribute('data-in', '');
  }));

  const box = q('newsletterForm');
  if (box && box.closest('form')) box.closest('form').addEventListener('submit', () => box.style.setProperty('--newsletter-done', 1));
  if (location.search.indexOf('customer_posted=true') > -1 && box) box.style.setProperty('--newsletter-done', 1);

  // Logo im Kopf ohne Hero (Unterseiten) sofort sichtbar
  if (!hero && lettermark) lettermark.style.setProperty('--nav-logo-opacity', 1);
  if (!footer) { const f = document.querySelector('footer'); if (f) f.style.setProperty('--fr', 1); }

  // Social-Karussell: gestapelte Karten, Ziehen mit Federung (Aussehen: kindl.css Block 8)
  document.querySelectorAll('[data-k-carousel]').forEach(node => {
    const cards = [...node.querySelectorAll('[data-ksc-card]')];
    const total = cards.length;
    if (!total) return;
    const drag = node.querySelector('[data-ksc-drag]');
    const stack = node.querySelector('.ksc__stack');
    const halb = total / 2;

    // Ziehgefühl (distanz, tempo, empfindlich) haengt am Fenster, die Optik nicht:
    // xMul/yMul/drehMul/skalaAb sind hier nur die Obergrenze aus der Vorlage.
    const stufe = () => innerWidth < 640
      ? { distanz: 120, tempo: 500, empfindlich: 180, xMul: 90, yMul: 20, drehMul: 8, skalaAb: .06 }
      : innerWidth < 1024
        ? { distanz: 160, tempo: 650, empfindlich: 220, xMul: 130, yMul: 30, drehMul: 10, skalaAb: .09 }
        : { distanz: 200, tempo: 800, empfindlich: 250, xMul: 170, yMul: 40, drehMul: 12, skalaAb: .12 };

    // Der Faecher richtet sich nach dem CONTAINER, nicht nach dem Fenster: das Karussell
    // steht in einer Rasterspalte, die viel schmaler ist als die Seite. Sonst schiebt es
    // die hinteren Karten aus dem overflow:hidden heraus und sie enden an einer harten Kante.
    const konfig = () => {
      const s = stufe();
      const breite = node.getBoundingClientRect().width || innerWidth;
      const karte = stack ? stack.getBoundingClientRect().width : 0;
      const rand = Math.max(0, (breite - karte) / 2);      // freier Platz je Seite
      // 2.2: die Karte bei Abstand 2 bleibt knapp drin. Nach oben der Stufenwert
      // (breiter Container faechert nicht staerker als die Vorlage), nach unten 40
      // (sonst faellt der Stapel zur Deckung zusammen).
      const xMul = Math.min(s.xMul, Math.max(40, rand / 2.2));
      const faktor = xMul / s.xMul;                        // Anmutung mitskalieren
      // Randmaske schmaler als der freie Rand - sie tastet die vorderste Karte nie an.
      node.style.setProperty('--ksc-fade', Math.round(Math.min(rand * .6, 72)) + 'px');
      return { ...s, xMul, yMul: s.yMul * faktor, drehMul: s.drehMul * faktor, skalaAb: s.skalaAb * faktor };
    };
    let cfg = konfig();

    // Lineare Interpolation über Stützstellen
    const interp = (wert, stops, werte) => {
      if (wert <= stops[0]) return werte[0];
      for (let i = 0; i < stops.length - 1; i++) {
        if (wert <= stops[i + 1]) {
          const spanne = stops[i + 1] - stops[i];
          return spanne <= 0 ? werte[i + 1] : mix(werte[i], werte[i + 1], (wert - stops[i]) / spanne);
        }
      }
      return werte[werte.length - 1];
    };
    const opStops = [-halb, -halb + .5, 0, halb - .5, halb];

    let progress = 0, ziel = 0, tempo = 0, raf = 0, zuletzt = 0, ziehend = false;

    function paint() {
      for (let i = 0; i < total; i++) {
        let diff = (i - progress) % total;
        if (diff > halb) diff -= total;
        if (diff < -halb) diff += total;
        const abs = Math.abs(diff);
        const dreh = abs < .05 ? 0 : diff * cfg.drehMul;
        const y = abs < .05 ? 0 : abs * cfg.yMul;
        const s = cards[i].style;
        s.transform = 'translate3d(' + (diff * cfg.xMul).toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) scale(' + (1 - abs * cfg.skalaAb).toFixed(4) + ') rotate(' + dreh.toFixed(3) + 'deg)';
        s.opacity = interp(diff, opStops, [0, 1, 1, 1, 0]).toFixed(3);
        s.zIndex = Math.round(100 - abs * 10);
        s.setProperty('--ksc-shade', interp(diff, [-2, -.5, 0, .5, 2], [.5, .2, 0, .2, .5]).toFixed(3));
        s.setProperty('--ksc-meta', interp(diff, [-.5, 0, .5], [0, 1, 0]).toFixed(3));
        // vorderste Karte merken: nur sie reagiert auf Hover (die Ziehfläche liegt darüber)
        cards[i].classList.toggle('is-vorn', abs < .5);
      }
    }

    // Feder von Hand: stiffness 200, damping 30, mass 1 — in festen Teilschritten integriert
    function feder(ts) {
      raf = 0;
      const dt = Math.min((ts - zuletzt) / 1000, .064);
      zuletzt = ts;
      const schritte = Math.max(1, Math.ceil(dt * 240));
      const h = dt / schritte;
      for (let n = 0; n < schritte; n++) {
        tempo += (-200 * (progress - ziel) - 30 * tempo) * h;
        progress += tempo * h;
      }
      if (Math.abs(progress - ziel) > .0005 || Math.abs(tempo) > .0005) { paint(); raf = requestAnimationFrame(feder); }
      else { progress = ziel; tempo = 0; paint(); }
    }
    const federStart = () => {
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      if (reduced.matches) { progress = ziel; tempo = 0; paint(); return; }
      zuletzt = performance.now();
      raf = requestAnimationFrame(feder);
    };
    // kürzester Weg zu einer Karte, über den Stapelrand hinweg
    const zuIndex = i => {
      const jetzt = Math.round(progress);
      let d = ((i - jetzt) % total + total) % total;
      if (d > halb) d -= total;
      ziel = jetzt + d;
      federStart();
    };

    if (drag && total > 1) {
      let startX = 0, startProgress = 0, letzteX = 0, letzteZeit = 0, vx = 0, weg = 0;
      drag.addEventListener('pointerdown', e => {
        if (raf) { cancelAnimationFrame(raf); raf = 0; }
        ziehend = true; tempo = 0; weg = 0; vx = 0;
        startX = letzteX = e.clientX; startProgress = progress; letzteZeit = e.timeStamp;
        try { drag.setPointerCapture(e.pointerId); } catch (err) { /* ältere Browser */ }
        node.classList.add('is-ziehend');
        node.focus({ preventScroll: true });
        e.preventDefault();
      }, { signal: sig });

      drag.addEventListener('pointermove', e => {
        if (!ziehend) return;
        const delta = e.clientX - letzteX;
        const dt = Math.max(e.timeStamp - letzteZeit, 1);
        vx = delta / dt * 1000;
        letzteX = e.clientX; letzteZeit = e.timeStamp;
        weg += Math.abs(delta);
        progress += -delta / cfg.empfindlich;
        paint();
      }, { signal: sig });

      const loslassen = e => {
        if (!ziehend) return;
        ziehend = false;
        node.classList.remove('is-ziehend');
        try { if (drag.hasPointerCapture(e.pointerId)) drag.releasePointerCapture(e.pointerId); } catch (err) { /* ignorieren */ }
        // Kurzer Tipp statt Ziehen: Link der vordersten Karte öffnen
        if (weg < 6 && e.type === 'pointerup') {
          ziel = Math.round(startProgress); federStart();
          const vorn = cards[((Math.round(progress) % total) + total) % total];
          const link = vorn && vorn.querySelector('a.ksc__link');
          if (link) link.click();
          return;
        }
        const verschiebung = -(e.clientX - startX) / cfg.distanz + -vx / cfg.tempo;
        ziel = Math.round(startProgress) + Math.max(-3, Math.min(3, Math.round(verschiebung)));
        federStart();
      };
      drag.addEventListener('pointerup', loslassen, { signal: sig });
      drag.addEventListener('pointercancel', loslassen, { signal: sig });
      drag.addEventListener('dragstart', e => e.preventDefault(), { signal: sig });

      node.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        ziel = Math.round(progress) + (e.key === 'ArrowRight' ? 1 : -1);
        federStart();
      }, { signal: sig });
    }

    // Tastatur-Fokus auf einer Karte holt sie nach vorn
    cards.forEach((card, i) => card.addEventListener('focusin', () => { if (!ziehend) zuIndex(i); }, { signal: sig }));

    addEventListener('resize', () => { cfg = konfig(); paint(); }, { passive: true, signal: sig });
    // Die Spalte kann sich auch ohne Fensterwechsel aendern (Raster, Bilder, Schrift).
    if (self.ResizeObserver) {
      const ro = new ResizeObserver(() => { cfg = konfig(); paint(); });
      ro.observe(node); observers.push(ro);
    }
    reduced.addEventListener('change', () => { if (reduced.matches) { progress = ziel; tempo = 0; paint(); } }, { signal: sig });
    sig.addEventListener('abort', () => { if (raf) cancelAnimationFrame(raf); });
    paint();
  });

  // Produktseite: Variantenwahl
  const vNode = document.getElementById('kindl-variants');
  if (vNode) {
    const variants = JSON.parse(vNode.textContent || '[]');
    const selects = [...document.querySelectorAll('[data-kindl-option]')];
    const idField = document.getElementById('kindl-variant-id');
    const priceEl = document.getElementById('kindl-price');
    const addBtn = document.getElementById('kindl-add');
    const money = cents => (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2 }) + ' €';
    const sync = () => {
      const chosen = selects.map(s => s.value);
      const v = variants.find(v => chosen.every((val, i) => v.options[i] === val)) || variants[0];
      if (!v) return;
      if (idField) idField.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft'; }
    };
    selects.forEach(s => s.addEventListener('change', sync));
    if (selects.length) sync();
    document.querySelectorAll('[data-kindl-thumb]').forEach(btn => btn.addEventListener('click', () => {
      const src = btn.getAttribute('data-kindl-thumb');
      const main = document.getElementById('kindl-main-image');
      if (main) main.src = src;
      const stage = document.getElementById('kindl-stage-image');
      if (stage) stage.src = src;
      document.querySelectorAll('[data-kindl-thumb]').forEach(b => b.style.borderColor = b === btn ? '#8f231e' : '#1d1d1f1a');
    }));
  }

  request();
  }
  boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', boot);
  document.addEventListener('shopify:section:reorder', boot);
})();